module.exports = __webpack_public_path__ + "static/media/firmaYa.c78f8520.svg";